import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidenav from "./Sidenavbar";
import Header from "./Header";
import LayoutFooter from "./Footer";

export default function DashboardLayout() {

    const [collapsed, setCollapsed] = useState(false);

    const [mobileOpen, setMobileOpen] = useState(false);

    return (

        <div className="layout-wrapper d-flex flex-column min-vh-100">

            <Sidenav
                collapsed={collapsed}
                mobileOpen={mobileOpen}
                onExpand={() => setCollapsed(false)}
            />



            {mobileOpen && (

                <div
                    className="sidebar-overlay"
                    onClick={() => setMobileOpen(false)}
                />

            )}



            <Header
                collapsed={collapsed}
                onToggle={() =>
                    setCollapsed(prev => !prev)
                }
                onMenuToggle={() =>
                    setMobileOpen(prev => !prev)
                }
            />



            <main
                className={`main-content flex-grow-1${collapsed
                    ? " sidebar-collapsed"
                    : ""
                    }`}
                onClick={() => {

                    if (mobileOpen) {

                        setMobileOpen(false);
                    }

                }}
            >

                <Outlet />

            </main>


            <LayoutFooter collapsed={collapsed} />

        </div>

    );
}